<template>
    <aside v-if="visible"
           class="landlord-journey-hud"
           :class="variantClass"
           role="status"
           aria-live="polite"
           :aria-label="label">
        <div class="landlord-journey-hud__inner">
            <span class="landlord-journey-hud__label">{{ label }}</span>
            <div class="landlord-journey-hud__track"
                 :aria-valuenow="step"
                 :aria-valuemin="0"
                 :aria-valuemax="total"
                 :aria-label="label"
                 role="progressbar">
                <div class="landlord-journey-hud__fill"
                     :style="{ width: clampedPercent + '%' }"></div>
            </div>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'LandlordJourneyHud',
    props: {
        visible:          { type: Boolean, default: false },
        step:             { type: Number,  default: 0 },
        total:            { type: Number,  default: 6 },
        label:            { type: String,  default: '' },
        progressPercent:  { type: Number,  default: 0 },
        variant:          { type: String,  default: 'concept' },
    },
    computed: {
        clampedPercent: function () {
            var v = Number(this.progressPercent) || 0;
            return Math.max(0, Math.min(100, v));
        },
        variantClass: function () {
            return this.variant === 'live'
                ? 'landlord-journey-hud--live'
                : 'landlord-journey-hud--concept';
        },
    },
};
</script>
